module.exports = __webpack_public_path__ + "static/media/act-1.839ad2e2.mp3";